import { useContext, useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../assets/css/seleccion-masiva.min.css";
import "./nuevo-candidato.css";
import InputRutCustomized from "../kit-mdtw/InputRutCustomized";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CircularProgress from "@mui/material/CircularProgress";
import ModalUpdateCandidate from "../kit-mdtw/modals/modalUpdateCandidate/ModalUpdateCandidate";
import SeleccionContext from "../../../context/Seleccion/SeleccionContext";
import ModalEncuesta from "../../pages/Campaign/ModalEncuesta";
import ModalGenerico from "../kit-modal/ModalGenerico";
import ModalSolicitarRegistro from "../../pages/Seleccion/RegistroPorValidarMasivo/Modal/ModalSolicitarRegistro";
import CargaNominaNew from "./CargaNominaNew";
import CargaNominaPortales from "./CargaNominaPortales";
import CargaNominaIngesta from "./CargaNominaIngesta";
import { PROFILE_ADMIN_SEL } from "../../../diccionary/Diccionary";

interface INuevoCandidato {
  cargarNomina?: Function;
  getCandidates?: Function;
}

const BlockedCommentTooltip = ({ comentario }: { comentario: string }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleDocClick = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleDocClick);
    return () => document.removeEventListener("mousedown", handleDocClick);
  }, [open]);

  return (
    <span
      ref={wrapperRef}
      style={{
        position: "relative",
        display: "inline-flex",
        verticalAlign: "middle",
        marginLeft: 10,
      }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {/* Chip con texto, no otro ícono (i): el aviso ya lleva un ícono a la
          izquierda y dos casi iguales se confundían. */}
      <button
        type="button"
        className="nc-comment-chip"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        aria-expanded={open}
        aria-label="Ver comentario del bloqueo"
      >
        <ChatBubbleOutlineIcon />
        Ver comentario
      </button>
      {open && (
        <span
          role="tooltip"
          style={{
            position: "absolute",
            bottom: "calc(100% + 8px)",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#404040",
            color: "#fff",
            padding: "8px 12px",
            borderRadius: 6,
            fontFamily: "Inter",
            fontStyle: "normal",
            fontSize: 13,
            fontWeight: 500,
            lineHeight: 1.4,
            whiteSpace: "normal",
            width: "max-content",
            maxWidth: 320,
            textAlign: "left",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            zIndex: 999999,
            pointerEvents: "none",
          }}
        >
          {comentario}
          <span
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderStyle: "solid",
              borderWidth: "6px 6px 0 6px",
              borderColor: "#404040 transparent transparent transparent",
            }}
          />
        </span>
      )}
    </span>
  );
};

/**
 * Pone en negrita los datos del mensaje "Persona existente en el sistema:
 * Ingresado el <fecha> por <reclutador> y activo en el <proceso ID n, grupo g>
 * en estado <estado> (...)" que arma el backend (persona-logic). Si el texto no
 * calza con ese formato se muestra tal cual.
 */
const MENSAJE_EXISTENTE =
  /^(.*?Ingresado el )(\S+)( por )(.+?)( y activo en el )(.+?)( en estado )(.+?)( \(.*\))?$/;

// "proceso ID n", "grupo g" o "proceso ID n, grupo g" (buildProcessMessage).
const resaltarProceso = (texto: string) => {
  const conId = /^proceso ID (\S+?)(?:, grupo (.+))?$/.exec(texto);
  if (conId) {
    return (
      <>
        proceso ID <strong>{conId[1]}</strong>
        {conId[2] && (
          <>
            , grupo <strong>{conId[2]}</strong>
          </>
        )}
      </>
    );
  }
  const soloGrupo = /^grupo (.+)$/.exec(texto);
  if (soloGrupo) {
    return (
      <>
        grupo <strong>{soloGrupo[1]}</strong>
      </>
    );
  }
  return <>{texto}</>;
};

const MensajeRut = ({ texto }: { texto: string }) => {
  const m = MENSAJE_EXISTENTE.exec(texto);
  if (!m) return <>{texto}</>;
  const [, inicio, fecha, por, reclutador, activo, proceso, enEstado, estado, cola] = m;
  return (
    <>
      {inicio}
      <strong>{fecha}</strong>
      {por}
      <strong>{reclutador}</strong>
      {activo}
      {resaltarProceso(proceso)}
      {enEstado}
      <strong>{estado}</strong>
      {cola ?? ""}
    </>
  );
};

export default (props: INuevoCandidato) => {
  const { getCandidates } = props;
  const profile: string = sessionStorage.getItem("profile") ?? "";
  const isAdmin = PROFILE_ADMIN_SEL.includes(profile);
  const {
    token,
    getToken,
    listaGeneral,
    getRutVerificado,
    postSolicitarCandidato,
    postLiberarCandidato,
    emptyMessage,
    personaVerificarRut,
    procesoVerificarRut,
  } = useContext(SeleccionContext);
  const [isOpenModalUpdate, setIsOpenModalUpdate] = useState<boolean>(false);
  const [uploadModalVisible, setUploadModalVisible] = useState<boolean>(false);
  const [portalPayrollModalVisible, setPortalPayrollModalVisible] = useState<boolean>(false);
  const [portalModalVisible, setPortalModalVisible] = useState<boolean>(false);
  const [isOpenModalSolicitar, setIsOpenModalSolicitar] =
    useState<boolean>(false);
  const [resultBusperId, setResultBusperId] = useState<string | undefined>(
    undefined
  );
  const [isOpenModalCampaign, setIsOpenModalCampaign] =
    useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(true);
  const [hidden, setHidden] = useState<boolean>(false);
  const [isFree, setIsFree] = useState<boolean | undefined>(undefined);
  const [isFreeSolicitar, setIsFreeSolicitar] = useState<boolean | undefined>(
    undefined
  );
  const [isLiberar, setIsLiberar] = useState<boolean>(false);
  const [isOpenModalLiberar, setIsOpenModalLiberar] = useState<boolean>(false);
  const [isLoadingLiberar, setIsLoadingLiberar] = useState<boolean>(false);
  const [solicitudes, setSolicitudes] = useState<any>([]);
  const [candidateSelect, setCandidateSelect] = useState<any[]>([]);
  const [selectedProcesoDestino, setSelectedProcesoDestino] = useState<string | undefined>(undefined);
  const [selectedComentario, setSelectedComentario] = useState<string>("");
  const [solEnviada, setSolEnviada] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // El texto de ayuda "Ingrese Rut y presione Revisar Rut…" se quitó por ser
  // demasiada información; esta variable ahora solo muestra el RESULTADO de
  // consultar el RUT (libre, bloqueado, etc.).
  const [messageSpanish, setMessageSpanish] = useState<string>("");
  const [blockedComment, setBlockedComment] = useState<string | undefined>(
    undefined
  );
  const [rut, setRut] = useState<string | undefined>("");
  const [rutCopy, setRutCopy] = useState<string | undefined>("");

  useEffect(() => {
    if (resultBusperId) {
      setIsOpenModalCampaign(true);
    }
  }, [resultBusperId]);

  useEffect(() => {
    setRutCopy(rut);
  }, [rut]);

  useEffect(() => {
    if (rut !== rutCopy) {
      setMessageSpanish("");
      setIsFree(undefined);
      setIsFreeSolicitar(undefined);
      setIsLiberar(false);
      setBlockedComment(undefined);
    }
    setRutCopy(rut);
  }, [rut]);

  useEffect(() => {
    if (solEnviada) {
      setMessageSpanish(
        "* Solicitud de registro enviada, revisa en la sección Traspasos el estado de esta solicitud"
      );
    }
  }, [solEnviada]);

  const handleClickModalUpdate = () => {
    setIsOpenModalUpdate(true);
  };

  const handleClickCargarNomina = () => {
    setUploadModalVisible(true);
  };

  const handleDescargarPlantilla = () => {
    const enlace = document.createElement("a");
    enlace.href = `${process.env.REACT_APP_DESC_TEMP_NOMINA}`;
    enlace.download = "TEMPLATE_NOMINA_SELECCION.xlsx";
    document.body.appendChild(enlace);
    enlace.click();
    document.body.removeChild(enlace);
  };

  const handleClickVerificarRut = (values: any) => {
    const { personaRut } = values;
    getRutVerificado({
      personaRut,
      setIsFree,
      setIsFreeSolicitar,
      setIsLiberar,
      setMessageSpanish,
      setBlockedComment,
      setLoading: setIsLoading,
      setButtonDisabled,
      consultaRut: true,
      token,
    });
  };

  const handleClickSolicitar = () => {
    setIsOpenModalSolicitar(true);
    setCandidateSelect([rut as string]);
  };

  const handleClickSolicitarCandidato = async (values: any) => {
    const { procesoDestino } = values;
    const procesoId = procesoDestino ?? selectedProcesoDestino;
    if (token && procesoId) {
      await postSolicitarCandidato({
        token,
        solicitudes: [{
          personaId: (personaVerificarRut as any)?.personaId,
          procesoId,
          comentario: selectedComentario ?? "",
        }],
      });
    }
  };

  // Tono del aviso con el resultado de consultar el RUT.
  const tonoResultado: "info" | "ok" | "danger" =
    isFree === false ? (solEnviada ? "ok" : "danger") : isFree ? "ok" : "info";
  const puedeLiberar: boolean = !!(isLiberar || (isAdmin && isFreeSolicitar));

  return (
    <>
      <section className="nc-card">
        <button
          type="button"
          className="nc-header"
          onClick={() => setHidden(!hidden)}
          aria-expanded={!hidden}
        >
          <span className="nc-header-icon">
            <PersonAddAlt1Icon style={{ fontSize: 20 }} />
          </span>
          <span className="nc-header-text">
            <h4 className="nc-title">Registro Nuevo Candidato</h4>
            {!hidden && (
              <span className="nc-subtitle">
                Consulta el RUT para saber si el candidato está disponible y continuar con su registro.
              </span>
            )}
          </span>
          <motion.span
            className="nc-toggle"
            animate={{ rotate: hidden ? 0 : 180 }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
          >
            <ExpandMoreIcon />
          </motion.span>
        </button>

        <AnimatePresence initial={false}>
          {!hidden && (
            <motion.div
              className="nc-body"
              key="nuevo-candidato-content"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
              style={{ overflow: "hidden" }}
            >
              <div className="nc-steps">
                <div className="nc-step nc-step-search">
                  <div
                    className="nc-search-row"
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !buttonDisabled) {
                        handleClickVerificarRut({ personaRut: rut });
                      }
                    }}
                  >
                    <div className="nc-rut-field">
                      <InputRutCustomized
                        layer="Rut (*)"
                        placeholder="Ej: 12345678-9"
                        validacion={setButtonDisabled}
                        setValue={setRut}
                        errorPosition="down"
                        maxLength={10}
                        required={false}
                      />
                    </div>
                    <button
                      type="button"
                      className={`nc-btn nc-btn-primary${isLoading ? " nc-btn-loading" : ""}`}
                      disabled={buttonDisabled || isLoading}
                      aria-busy={isLoading}
                      onClick={() => handleClickVerificarRut({ personaRut: rut })}
                    >
                      {isLoading ? (
                        <CircularProgress size={17} thickness={5} sx={{ color: "#fff" }} />
                      ) : (
                        <SearchIcon />
                      )}
                      {isLoading ? "Revisando…" : "Revisar RUT"}
                    </button>
                  </div>
                </div>

                <div className="nc-step nc-step-actions">
                  <div className="nc-actions">
                    <button
                      type="button"
                      className="nc-btn nc-btn-success"
                      onClick={handleClickModalUpdate}
                      disabled={!isFree}
                      value={rut}
                    >
                      <HowToRegIcon />
                      Continuar Registro
                    </button>
                    <button
                      type="button"
                      className="nc-btn nc-btn-warning"
                      onClick={handleClickSolicitar}
                      disabled={!isFreeSolicitar}
                    >
                      <PersonAddAlt1Icon />
                      Solicitar Candidato
                    </button>
                    <button
                      type="button"
                      className="nc-btn nc-btn-danger"
                      disabled={!puedeLiberar}
                      onClick={() => setIsOpenModalLiberar(true)}
                    >
                      <ExitToAppIcon />
                      Liberar Candidato
                    </button>
                  </div>
                </div>
              </div>

              {messageSpanish && (
                <div className={`nc-result nc-result-${tonoResultado}`} role="status">
                  {tonoResultado === "ok" ? (
                    <CheckCircleOutlineIcon />
                  ) : tonoResultado === "danger" ? (
                    <ErrorOutlineIcon />
                  ) : (
                    <InfoOutlinedIcon />
                  )}
                  <span>
                    {blockedComment !== undefined ? (
                      <>
                        <strong>{messageSpanish}</strong>
                        <BlockedCommentTooltip comentario={blockedComment} />
                      </>
                    ) : (
                      <MensajeRut texto={messageSpanish} />
                    )}
                  </span>
                </div>
              )}

              <footer className="nc-footer">
                <div className="nc-footer-actions">
                  <button
                    type="button"
                    className="nc-btn nc-btn-excel-ghost"
                    onClick={handleDescargarPlantilla}
                  >
                    <DownloadIcon />
                    Descargar Plantilla
                  </button>
                  {/* Botones de carga de portales ocultos temporalmente: la
                      funcionalidad de portales/ingesta queda en pausa (se
                      retomará más adelante). Los imports, estados y modales
                      (CargaNominaPortales / CargaNominaIngesta) siguen intactos:
                      reactivarlos es quitar este `false &&`. */}
                  {false && (
                    <>
                      <button
                        type="button"
                        className="nc-btn nc-btn-excel-ghost"
                        onClick={() => setPortalPayrollModalVisible(true)}
                      >
                        <UploadFileIcon />
                        Cargar Nómina Portales
                      </button>
                      <button
                        type="button"
                        className="nc-btn nc-btn-excel-ghost"
                        onClick={() => setPortalModalVisible(true)}
                      >
                        <UploadFileIcon />
                        Carga de Portales
                      </button>
                    </>
                  )}
                  <button
                    type="button"
                    className="nc-btn nc-btn-excel"
                    onClick={handleClickCargarNomina}
                  >
                    <UploadFileIcon />
                    Cargar Nómina
                  </button>
                </div>
              </footer>
            </motion.div>
          )}
        </AnimatePresence>
      </section>

      {isOpenModalUpdate && (
        <ModalUpdateCandidate
          title="Registro Candidato"
          subTitle="Puede cambiar al candidato de proceso en cualquier momento, Todos los datos con (*) son obligatorios y deben ser completados antes de avanzar al candidato a la siguiente etapa del proceso."
          setIsOpenModalUpdateCandidate={setIsOpenModalUpdate}
          setResultBusperId={setResultBusperId}
          token={token}
          rut={rut}
          getCandidates={getCandidates}
          onChangeBack={() => {
            setIsOpenModalUpdate(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          onChangeGo={() => {
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        />
      )}

      {isOpenModalCampaign && (
        <ModalEncuesta
          modalStyle="confirm"
          title="Solicite realizar la siguiente encuesta al candidato"
          onChangeBack={() => setIsOpenModalCampaign(false)}
          buttonBack="Cancelar"
          busPerId={resultBusperId}
        />
      )}

      {isOpenModalSolicitar && (
        <ModalGenerico
          width="w-90"
          title="SOLICITAR CANDIDATO"
          onChangeBack={() => {
            setIsOpenModalSolicitar(false);
            setCandidateSelect([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
          buttonBackText="Cerrar"
          buttonGoText="Solicitar"
          buttonGoStyle="confirm"
          buttonGoDisable={!!selectedProcesoDestino}
          onChangeGo={() => {
            handleClickSolicitarCandidato({ procesoDestino: selectedProcesoDestino });
            setIsOpenModalSolicitar(false);
            setCandidateSelect([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
        >
          <ModalSolicitarRegistro
            rut={candidateSelect}
            solicitudes={solicitudes}
            setSolicitudes={setSolicitudes}
            handleClickSolicitarCandidato={handleClickSolicitarCandidato}
            onChangeBack={() => {
              setIsOpenModalSolicitar(false);
              setCandidateSelect([]);
              setSelectedProcesoDestino(undefined);
              setSelectedComentario("");
            }}
            onSelectProceso={(value: string) => setSelectedProcesoDestino(value)}
            onComentario={(value: string) => setSelectedComentario(value)}
          />
        </ModalGenerico>
      )}

      {uploadModalVisible && (
        <CargaNominaNew
          token={token}
          getToken={getToken}
          uploadModalVisible={uploadModalVisible}
          setUploadModalVisible={setUploadModalVisible}
          emptyMessage={emptyMessage}
        />
      )}

      {portalModalVisible && (
        <CargaNominaIngesta
          token={token}
          getToken={getToken}
          uploadModalVisible={portalModalVisible}
          setUploadModalVisible={setPortalModalVisible}
          busquedaId={selectedProcesoDestino}
        />
      )}

      {portalPayrollModalVisible && (
        <CargaNominaPortales
          visible={portalPayrollModalVisible}
          onHide={() => setPortalPayrollModalVisible(false)}
        />
      )}

      {isOpenModalLiberar && (
        <ModalGenerico
          width="w-40"
          title="LIBERAR CANDIDATO"
          onChangeBack={() => setIsOpenModalLiberar(false)}
          buttonBackText="Cancelar"
          buttonGoText="Liberar"
          buttonGoStyle="delete"
          onChangeGo={async () => {
            const busPerId = (procesoVerificarRut as any)?.busPerId;
            if (busPerId) {
              await postLiberarCandidato({
                token,
                releases: [busPerId],
                setIsLoading: setIsLoadingLiberar,
              });
            }
            setIsOpenModalLiberar(false);
            setIsLiberar(false);
          }}
        >
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "8px 0px 12px",
            width: "100%",
          }}>
            <div style={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: "#FEF2F2",
              border: "2px solid #FECACA",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <ExitToAppIcon style={{ fontSize: 38, color: "#DC2626" }} />
            </div>

            <div style={{
              background: "#F9FAFB",
              border: "1px solid #E5E7EB",
              borderRadius: "10px",
              padding: "12px 24px",
              width: "100%",
              textAlign: "center",
              boxSizing: "border-box",
            }}>
              <p style={{ margin: 0, fontSize: 12, color: "#9CA3AF", marginBottom: 4 }}>RUT del candidato</p>
              <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#1F2937", letterSpacing: "0.5px" }}>{rut}</p>
            </div>

            <p style={{
              margin: 0,
              color: "#6B7280",
              fontSize: 14,
              textAlign: "center",
              lineHeight: 1.7,
            }}>
              Al liberar este candidato quedará{" "}
              <strong style={{ color: "#DC2626" }}>disponible para otros reclutadores</strong>.
              <br />
              Esta acción no puede deshacerse.
            </p>
          </div>
        </ModalGenerico>
      )}

      { }
    </>
  );
};
